import React from 'react';
import { useAttendanceHistoryList } from './hooks/useAttendanceHistoryList';
import SharedFilters from '../../../components/SharedFilters';
import AppPagination from '../../../components/AppPagination';
import AttendanceHistoryTable from './components/AttendanceHistoryTable';
import AttendanceSwipesModal from './components/AttendanceSwipesModal';

export default function AttendanceHistoryListScreen() {
  const { state, actions } = useAttendanceHistoryList();
  const { employeeInfo } = state;

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner */}
      <section className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between border-b border-outline-variant/15 pb-4">
        <div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-on-surface">
            Attendance History
          </h1>
          <p className="mt-1 text-xs text-on-surface-variant font-medium">
            Daily punch records &amp; swipe logs
          </p>
        </div>
      </section>

      {/* Shared Filters Accordion */}
      <SharedFilters
        searchField={state.searchField}
        searchText={state.searchText}
        showStatus={false}
        attendanceStatusFilter={state.attendanceStatusFilter}
        datePresetFilter={state.datePresetFilter}
        fromDate={state.fromDate}
        toDate={state.toDate}

        setSearchField={actions.setSearchField}
        setSearchText={actions.setSearchText}
        setAttendanceStatusFilter={actions.setAttendanceStatusFilter}
        setDatePresetFilter={actions.setDatePresetFilter}
        setFromDate={actions.setFromDate}
        setToDate={actions.setToDate}

        onSearch={actions.handleSearch}
        onReset={actions.resetFilters}

        searchFieldOptions={state.searchFieldOptions}
        attendanceStatusOptions={state.attendanceStatusOptions}
        datePresetOptions={state.datePresetOptions}

        visibleAccordionFilters={[
          'attendanceStatus',
          'datePreset',
          'fromDate',
          'toDate',
        ]}

        tools={state.tools}
        onToolSelect={actions.handleToolSelect}
      />

      {/* Attendance History Table */}
      <section className="space-y-4">
        <AttendanceHistoryTable
          records={state.records}
          onViewSwipes={actions.handleViewSwipes}
          onResetFilters={actions.resetFilters}
        />

        {/* Table Footer with Pagination */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-outline-variant/15 px-6 py-4 sm:flex-row bg-surface-container-lowest rounded-2xl shadow-xs">
          <p className="text-xs text-on-surface-variant font-medium">
            Showing {state.totalCount === 0 ? 0 : (state.page - 1) * state.pageSize + 1} to{' '}
            {Math.min(state.page * state.pageSize, state.totalCount)} of {state.totalCount} entries
          </p>
          <AppPagination
            page={state.page}
            totalPages={state.totalPages}
            onPageChange={actions.setPage}
            onPrevious={() => actions.setPage((p) => Math.max(p - 1, 1))}
            onNext={() => actions.setPage((p) => Math.min(p + 1, state.totalPages))}
            canPrevious={state.page > 1}
            canNext={state.page < state.totalPages}
          />
        </div>
      </section>

      {/* View All Swipes Detail Modal */}
      <AttendanceSwipesModal
        isOpen={state.isSwipesModalOpen}
        onClose={actions.handleCloseSwipesModal}
        record={state.selectedRecordForSwipes}
      />
    </div>
  );
}
